import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const toMapAsync = async (source, selector) => {
    const map = new Map();
    const dataFunc = nextIterationAsync(source, async (value) => {
        const key = await selector(value);
        return [key, value];
    });
    const keyValues = await typeDataToArray(dataFunc);
    for (const [key, value] of keyValues) {
        const array = map.get(key);
        if (array === undefined) {
            map.set(key, [value]);
        }
        else {
            array.push(value);
        }
    }
    return map;
};
